import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { tabStyle } from '../common/styles';

export const TabNavItem = ({ children, ...rest }: NavLinkProps) => (
  <NavLink css={tabStyle} {...rest} activeClassName="selected">
    {children}
  </NavLink>
);
